document.addEventListener('DOMContentLoaded', () => {
    const description = document.querySelector('.location__description');
    const readMoreBtn = document.querySelector('.read-more-btn');
    const i18n = window.singleLocationsI18n || { readMore: 'Read More', readLess: 'Read Less' };

    if (description && readMoreBtn) {
        readMoreBtn.addEventListener('click', () => {
            description.classList.toggle('expanded');
            if (description.classList.contains('expanded')) {
                readMoreBtn.innerHTML = '<span class="icon"></span> ' + i18n.readLess;
            } else {
                readMoreBtn.innerHTML = '<span class="icon"></span> ' + i18n.readMore;
            }
        });
    }
});
